export const ShieldAlert = ({ className }: { className: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.615 9.99986C16.615 15.357 8.99601 18.9284 8.99601 18.9284C8.99601 18.9284 1.37695 15.357 1.37695 9.99986V3.74986L8.99601 1.07129L16.615 3.74986V9.99986ZM10.0716 10.3685V6.17496H7.92874V10.3685H10.0716ZM10.199 13.3639C10.199 14.0256 9.66262 14.5621 9.00089 14.5621C8.33916 14.5621 7.80274 14.0256 7.80274 13.3639C7.80274 12.7022 8.33916 12.1658 9.00089 12.1658C9.66262 12.1658 10.199 12.7022 10.199 13.3639Z"
      fill="#FEC600"
    />
  </svg>
);

export const ShieldCheck = ({ className }: { className: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5735 10C16.5735 14.6875 9.90691 17.8125 9.90691 17.8125C9.90691 17.8125 3.24023 14.6875 3.24023 10V4.53125L9.90691 2.1875L16.5735 4.53125V10ZM13.5695 8.61682C13.8843 8.32172 13.9002 7.82732 13.6052 7.51255C13.31 7.19777 12.8157 7.18183 12.5008 7.47693L8.8685 10.8822L7.31948 9.43005C7.00471 9.13495 6.51031 9.1509 6.21521 9.46567C5.92011 9.78045 5.93606 10.2748 6.25083 10.57L8.33416 12.5231C8.63467 12.8048 9.10231 12.8048 9.40282 12.5231L13.5695 8.61682Z"
      fill="#65FC9F"
    />
  </svg>
);

export const Check = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3337 4L6.00033 11.3333L2.66699 8"
      stroke="white"
      strokeOpacity="0.7"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShieldOutline = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4866 12.0005L9.15329 2.66714C9.037 2.46194 8.86836 2.29127 8.66457 2.17252C8.46078 2.05378 8.22915 1.99121 7.99329 1.99121C7.75743 1.99121 7.52579 2.05378 7.322 2.17252C7.11822 2.29127 6.94958 2.46194 6.83329 2.66714L1.49995 12.0005C1.38241 12.204 1.32077 12.4351 1.32129 12.6701C1.32181 12.9052 1.38447 13.136 1.50292 13.339C1.62136 13.5421 1.79138 13.7102 1.99575 13.8264C2.20011 13.9425 2.43156 14.0026 2.66662 14.0005H13.3333C13.5672 14.0002 13.797 13.9385 13.9995 13.8213C14.202 13.7042 14.3701 13.5359 14.487 13.3332C14.6038 13.1306 14.6653 12.9007 14.6653 12.6668C14.6652 12.4329 14.6036 12.2031 14.4866 12.0005Z"
      stroke="white"
      strokeOpacity="0.7"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 6V8.66667"
      stroke="white"
      strokeOpacity="0.7"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 11.333H8.00667"
      stroke="white"
      strokeOpacity="0.7"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Arrow = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 2.5H9.5V5.5"
      stroke="white"
      strokeOpacity="0.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 2.5L2.5 9.5"
      stroke="white"
      strokeOpacity="0.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PriceSvg = () => (
  <svg
    width="320"
    height="249"
    viewBox="0 0 320 249"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_630_34108)">
      <rect
        width="320"
        height="249"
        rx="7"
        fill="url(#paint0_linear_630_34108)"
      />
      <g clip-path="url(#clip1_630_34108)">
        <mask id="path-3-inside-1_630_34108" fill="white">
          <path d="M0 168H317V169H0V168Z" />
        </mask>
        <path
          d="M0 169.5H1.50952V168.5H0V169.5ZM3.52222 169.5H6.54127V168.5H3.52222V169.5ZM8.55397 169.5H11.573V168.5H8.55397V169.5ZM13.5857 169.5H16.6048V168.5H13.5857V169.5ZM18.6175 169.5H21.6365V168.5H18.6175V169.5ZM23.6492 169.5H26.6683V168.5H23.6492V169.5ZM28.681 169.5H31.7V168.5H28.681V169.5ZM33.7127 169.5H36.7317V168.5H33.7127V169.5ZM38.7444 169.5H41.7635V168.5H38.7444V169.5ZM43.7762 169.5H46.7952V168.5H43.7762V169.5ZM48.8079 169.5H51.827V168.5H48.8079V169.5ZM53.8397 169.5H56.8587V168.5H53.8397V169.5ZM58.8714 169.5H61.8905V168.5H58.8714V169.5ZM63.9032 169.5H66.9222V168.5H63.9032V169.5ZM68.9349 169.5H71.954V168.5H68.9349V169.5ZM73.9667 169.5H76.9857V168.5H73.9667V169.5ZM78.9984 169.5H82.0175V168.5H78.9984V169.5ZM84.0302 169.5H87.0492V168.5H84.0302V169.5ZM89.0619 169.5H92.081V168.5H89.0619V169.5ZM94.0937 169.5H97.1127V168.5H94.0937V169.5ZM99.1254 169.5H102.144V168.5H99.1254V169.5ZM104.157 169.5H107.176V168.5H104.157V169.5ZM109.189 169.5H112.208V168.5H109.189V169.5ZM114.221 169.5H117.24V168.5H114.221V169.5ZM119.252 169.5H122.271V168.5H119.252V169.5ZM124.284 169.5H127.303V168.5H124.284V169.5ZM129.316 169.5H132.335V168.5H129.316V169.5ZM134.348 169.5H137.367V168.5H134.348V169.5ZM139.379 169.5H142.398V168.5H139.379V169.5ZM144.411 169.5H147.43V168.5H144.411V169.5ZM149.443 169.5H152.462V168.5H149.443V169.5ZM154.475 169.5H157.494V168.5H154.475V169.5ZM159.506 169.5H162.525V168.5H159.506V169.5ZM164.538 169.5H167.557V168.5H164.538V169.5ZM169.57 169.5H172.589V168.5H169.57V169.5ZM174.602 169.5H177.621V168.5H174.602V169.5ZM179.633 169.5H182.652V168.5H179.633V169.5ZM184.665 169.5H187.684V168.5H184.665V169.5ZM189.697 169.5H192.716V168.5H189.697V169.5ZM194.728 169.5H197.748V168.5H194.728V169.5ZM199.76 169.5H202.779V168.5H199.76V169.5ZM204.792 169.5H207.811V168.5H204.792V169.5ZM209.824 169.5H212.843V168.5H209.824V169.5ZM214.855 169.5H217.874V168.5H214.855V169.5ZM219.887 169.5H222.906V168.5H219.887V169.5ZM224.919 169.5H227.938V168.5H224.919V169.5ZM229.951 169.5H232.97V168.5H229.951V169.5ZM234.982 169.5H238.001V168.5H234.982V169.5ZM240.014 169.5H243.033V168.5H240.014V169.5ZM245.046 169.5H248.065V168.5H245.046V169.5ZM250.078 169.5H253.097V168.5H250.078V169.5ZM255.109 169.5H258.128V168.5H255.109V169.5ZM260.141 169.5H263.16V168.5H260.141V169.5ZM265.173 169.5H268.192V168.5H265.173V169.5ZM270.205 169.5H273.224V168.5H270.205V169.5ZM275.236 169.5H278.255V168.5H275.236V169.5ZM280.268 169.5H283.287V168.5H280.268V169.5ZM285.3 169.5H288.319V168.5H285.3V169.5ZM290.332 169.5H293.351V168.5H290.332V169.5ZM295.363 169.5H298.382V168.5H295.363V169.5ZM300.395 169.5H303.414V168.5H300.395V169.5ZM305.427 169.5H308.446V168.5H305.427V169.5ZM310.458 169.5H313.478V168.5H310.458V169.5ZM315.49 169.5H317V168.5H315.49V169.5ZM0 170H1.50952V168H0V170ZM3.52222 170H6.54127V168H3.52222V170ZM8.55397 170H11.573V168H8.55397V170ZM13.5857 170H16.6048V168H13.5857V170ZM18.6175 170H21.6365V168H18.6175V170ZM23.6492 170H26.6683V168H23.6492V170ZM28.681 170H31.7V168H28.681V170ZM33.7127 170H36.7317V168H33.7127V170ZM38.7444 170H41.7635V168H38.7444V170ZM43.7762 170H46.7952V168H43.7762V170ZM48.8079 170H51.827V168H48.8079V170ZM53.8397 170H56.8587V168H53.8397V170ZM58.8714 170H61.8905V168H58.8714V170ZM63.9032 170H66.9222V168H63.9032V170ZM68.9349 170H71.954V168H68.9349V170ZM73.9667 170H76.9857V168H73.9667V170ZM78.9984 170H82.0175V168H78.9984V170ZM84.0302 170H87.0492V168H84.0302V170ZM89.0619 170H92.081V168H89.0619V170ZM94.0937 170H97.1127V168H94.0937V170ZM99.1254 170H102.144V168H99.1254V170ZM104.157 170H107.176V168H104.157V170ZM109.189 170H112.208V168H109.189V170ZM114.221 170H117.24V168H114.221V170ZM119.252 170H122.271V168H119.252V170ZM124.284 170H127.303V168H124.284V170ZM129.316 170H132.335V168H129.316V170ZM134.348 170H137.367V168H134.348V170ZM139.379 170H142.398V168H139.379V170ZM144.411 170H147.43V168H144.411V170ZM149.443 170H152.462V168H149.443V170ZM154.475 170H157.494V168H154.475V170ZM159.506 170H162.525V168H159.506V170ZM164.538 170H167.557V168H164.538V170ZM169.57 170H172.589V168H169.57V170ZM174.602 170H177.621V168H174.602V170ZM179.633 170H182.652V168H179.633V170ZM184.665 170H187.684V168H184.665V170ZM189.697 170H192.716V168H189.697V170ZM194.728 170H197.748V168H194.728V170ZM199.76 170H202.779V168H199.76V170ZM204.792 170H207.811V168H204.792V170ZM209.824 170H212.843V168H209.824V170ZM214.855 170H217.874V168H214.855V170ZM219.887 170H222.906V168H219.887V170ZM224.919 170H227.938V168H224.919V170ZM229.951 170H232.97V168H229.951V170ZM234.982 170H238.001V168H234.982V170ZM240.014 170H243.033V168H240.014V170ZM245.046 170H248.065V168H245.046V170ZM250.078 170H253.097V168H250.078V170ZM255.109 170H258.128V168H255.109V170ZM260.141 170H263.16V168H260.141V170ZM265.173 170H268.192V168H265.173V170ZM270.205 170H273.224V168H270.205V170ZM275.236 170H278.255V168H275.236V170ZM280.268 170H283.287V168H280.268V170ZM285.3 170H288.319V168H285.3V170ZM290.332 170H293.351V168H290.332V170ZM295.363 170H298.382V168H295.363V170ZM300.395 170H303.414V168H300.395V170ZM305.427 170H308.446V168H305.427V170ZM310.458 170H313.478V168H310.458V170ZM315.49 170H317V168H315.49V170Z"
          fill="black"
          fillOpacity="0.24"
          mask="url(#path-3-inside-1_630_34108)"
        />
        <mask id="path-5-inside-2_630_34108" fill="white">
          <path d="M0 169H317V170H0V169Z" />
        </mask>
        <path
          d="M0 170.5H1.50952V169.5H0V170.5ZM3.52222 170.5H6.54127V169.5H3.52222V170.5ZM8.55397 170.5H11.573V169.5H8.55397V170.5ZM13.5857 170.5H16.6048V169.5H13.5857V170.5ZM18.6175 170.5H21.6365V169.5H18.6175V170.5ZM23.6492 170.5H26.6683V169.5H23.6492V170.5ZM28.681 170.5H31.7V169.5H28.681V170.5ZM33.7127 170.5H36.7317V169.5H33.7127V170.5ZM38.7444 170.5H41.7635V169.5H38.7444V170.5ZM43.7762 170.5H46.7952V169.5H43.7762V170.5ZM48.8079 170.5H51.827V169.5H48.8079V170.5ZM53.8397 170.5H56.8587V169.5H53.8397V170.5ZM58.8714 170.5H61.8905V169.5H58.8714V170.5ZM63.9032 170.5H66.9222V169.5H63.9032V170.5ZM68.9349 170.5H71.954V169.5H68.9349V170.5ZM73.9667 170.5H76.9857V169.5H73.9667V170.5ZM78.9984 170.5H82.0175V169.5H78.9984V170.5ZM84.0302 170.5H87.0492V169.5H84.0302V170.5ZM89.0619 170.5H92.081V169.5H89.0619V170.5ZM94.0937 170.5H97.1127V169.5H94.0937V170.5ZM99.1254 170.5H102.144V169.5H99.1254V170.5ZM104.157 170.5H107.176V169.5H104.157V170.5ZM109.189 170.5H112.208V169.5H109.189V170.5ZM114.221 170.5H117.24V169.5H114.221V170.5ZM119.252 170.5H122.271V169.5H119.252V170.5ZM124.284 170.5H127.303V169.5H124.284V170.5ZM129.316 170.5H132.335V169.5H129.316V170.5ZM134.348 170.5H137.367V169.5H134.348V170.5ZM139.379 170.5H142.398V169.5H139.379V170.5ZM144.411 170.5H147.43V169.5H144.411V170.5ZM149.443 170.5H152.462V169.5H149.443V170.5ZM154.475 170.5H157.494V169.5H154.475V170.5ZM159.506 170.5H162.525V169.5H159.506V170.5ZM164.538 170.5H167.557V169.5H164.538V170.5ZM169.57 170.5H172.589V169.5H169.57V170.5ZM174.602 170.5H177.621V169.5H174.602V170.5ZM179.633 170.5H182.652V169.5H179.633V170.5ZM184.665 170.5H187.684V169.5H184.665V170.5ZM189.697 170.5H192.716V169.5H189.697V170.5ZM194.728 170.5H197.748V169.5H194.728V170.5ZM199.76 170.5H202.779V169.5H199.76V170.5ZM204.792 170.5H207.811V169.5H204.792V170.5ZM209.824 170.5H212.843V169.5H209.824V170.5ZM214.855 170.5H217.874V169.5H214.855V170.5ZM219.887 170.5H222.906V169.5H219.887V170.5ZM224.919 170.5H227.938V169.5H224.919V170.5ZM229.951 170.5H232.97V169.5H229.951V170.5ZM234.982 170.5H238.001V169.5H234.982V170.5ZM240.014 170.5H243.033V169.5H240.014V170.5ZM245.046 170.5H248.065V169.5H245.046V170.5ZM250.078 170.5H253.097V169.5H250.078V170.5ZM255.109 170.5H258.128V169.5H255.109V170.5ZM260.141 170.5H263.16V169.5H260.141V170.5ZM265.173 170.5H268.192V169.5H265.173V170.5ZM270.205 170.5H273.224V169.5H270.205V170.5ZM275.236 170.5H278.255V169.5H275.236V170.5ZM280.268 170.5H283.287V169.5H280.268V170.5ZM285.3 170.5H288.319V169.5H285.3V170.5ZM290.332 170.5H293.351V169.5H290.332V170.5ZM295.363 170.5H298.382V169.5H295.363V170.5ZM300.395 170.5H303.414V169.5H300.395V170.5ZM305.427 170.5H308.446V169.5H305.427V170.5ZM310.458 170.5H313.478V169.5H310.458V170.5ZM315.49 170.5H317V169.5H315.49V170.5ZM0 171H1.50952V169H0V171ZM3.52222 171H6.54127V169H3.52222V171ZM8.55397 171H11.573V169H8.55397V171ZM13.5857 171H16.6048V169H13.5857V171ZM18.6175 171H21.6365V169H18.6175V171ZM23.6492 171H26.6683V169H23.6492V171ZM28.681 171H31.7V169H28.681V171ZM33.7127 171H36.7317V169H33.7127V171ZM38.7444 171H41.7635V169H38.7444V171ZM43.7762 171H46.7952V169H43.7762V171ZM48.8079 171H51.827V169H48.8079V171ZM53.8397 171H56.8587V169H53.8397V171ZM58.8714 171H61.8905V169H58.8714V171ZM63.9032 171H66.9222V169H63.9032V171ZM68.9349 171H71.954V169H68.9349V171ZM73.9667 171H76.9857V169H73.9667V171ZM78.9984 171H82.0175V169H78.9984V171ZM84.0302 171H87.0492V169H84.0302V171ZM89.0619 171H92.081V169H89.0619V171ZM94.0937 171H97.1127V169H94.0937V171ZM99.1254 171H102.144V169H99.1254V171ZM104.157 171H107.176V169H104.157V171ZM109.189 171H112.208V169H109.189V171ZM114.221 171H117.24V169H114.221V171ZM119.252 171H122.271V169H119.252V171ZM124.284 171H127.303V169H124.284V171ZM129.316 171H132.335V169H129.316V171ZM134.348 171H137.367V169H134.348V171ZM139.379 171H142.398V169H139.379V171ZM144.411 171H147.43V169H144.411V171ZM149.443 171H152.462V169H149.443V171ZM154.475 171H157.494V169H154.475V171ZM159.506 171H162.525V169H159.506V171ZM164.538 171H167.557V169H164.538V171ZM169.57 171H172.589V169H169.57V171ZM174.602 171H177.621V169H174.602V171ZM179.633 171H182.652V169H179.633V171ZM184.665 171H187.684V169H184.665V171ZM189.697 171H192.716V169H189.697V171ZM194.728 171H197.748V169H194.728V171ZM199.76 171H202.779V169H199.76V171ZM204.792 171H207.811V169H204.792V171ZM209.824 171H212.843V169H209.824V171ZM214.855 171H217.874V169H214.855V171ZM219.887 171H222.906V169H219.887V171ZM224.919 171H227.938V169H224.919V171ZM229.951 171H232.97V169H229.951V171ZM234.982 171H238.001V169H234.982V171ZM240.014 171H243.033V169H240.014V171ZM245.046 171H248.065V169H245.046V171ZM250.078 171H253.097V169H250.078V171ZM255.109 171H258.128V169H255.109V171ZM260.141 171H263.16V169H260.141V171ZM265.173 171H268.192V169H265.173V171ZM270.205 171H273.224V169H270.205V171ZM275.236 171H278.255V169H275.236V171ZM280.268 171H283.287V169H280.268V171ZM285.3 171H288.319V169H285.3V171ZM290.332 171H293.351V169H290.332V171ZM295.363 171H298.382V169H295.363V171ZM300.395 171H303.414V169H300.395V171ZM305.427 171H308.446V169H305.427V171ZM310.458 171H313.478V169H310.458V171ZM315.49 171H317V169H315.49V171Z"
          fill="white"
          fillOpacity="0.04"
          mask="url(#path-5-inside-2_630_34108)"
        />
        <rect
          x="-4.5"
          y="164.5"
          width="8"
          height="8"
          rx="4"
          fill="#1F1E1E"
          stroke="#2D3136"
        />
        <rect x="316" y="164" width="9" height="9" rx="4.5" fill="#1F1E1E" />
        <rect
          x="316.5"
          y="164.5"
          width="8"
          height="8"
          rx="4"
          stroke="white"
          strokeOpacity="0.04"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_630_34108"
        x1="48.6422"
        y1="-11.5853"
        x2="121.942"
        y2="296.172"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0166" stopColor="#7B6957" stopOpacity="0.5" />
        <stop offset="0.9786" stopColor="#171514" stopOpacity="0.5" />
      </linearGradient>
      <clipPath id="clip0_630_34108">
        <rect width="320" height="249" rx="7" fill="white" />
      </clipPath>
      <clipPath id="clip1_630_34108">
        <rect width="320" height="249" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DiscordIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z" />
  </svg>
);

export const GoogleIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24">
    <path
      fill="#EA4335"
      d="M5.26620003,9.76452941 C6.19878754,6.93863203 8.85444915,4.90909091 12,4.90909091 C13.6909091,4.90909091 15.2181818,5.50909091 16.4181818,6.49090909 L19.9090909,3 C17.7818182,1.14545455 15.0545455,0 12,0 C7.27006974,0 3.1977497,2.69829785 1.23999023,6.65002441 L5.26620003,9.76452941 Z"
    />
    <path
      fill="#34A853"
      d="M16.0407269,18.0125889 C14.9509167,18.7163016 13.5660892,19.0909091 12,19.0909091 C8.86648613,19.0909091 6.21911939,17.076871 5.27698177,14.2678769 L1.23746264,17.3349879 C3.19279051,21.2936293 7.26500293,24 12,24 C14.9328362,24 17.7353462,22.9573905 19.834192,20.9995801 L16.0407269,18.0125889 Z"
    />
    <path
      fill="#4A90E2"
      d="M19.834192,20.9995801 C22.0291676,18.9520994 23.4545455,15.903663 23.4545455,12 C23.4545455,11.2909091 23.3454545,10.5272727 23.1818182,9.81818182 L12,9.81818182 L12,14.4545455 L18.4363636,14.4545455 C18.1187732,16.013626 17.2662994,17.2212117 16.0407269,18.0125889 L19.834192,20.9995801 Z"
    />
    <path
      fill="#FBBC05"
      d="M5.27698177,14.2678769 C5.03832634,13.556323 4.90909091,12.7937589 4.90909091,12 C4.90909091,11.2182781 5.03443647,10.4668121 5.26620003,9.76452941 L1.23999023,6.65002441 C0.43658717,8.26043162 0,10.0753848 0,12 C0,13.9195484 0.444780743,15.7301709 1.23746264,17.3349879 L5.27698177,14.2678769 Z"
    />
  </svg>
);

export const DownArrow = ({ classes }: { classes?: string }) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path d="M0 0L5 5.83333L10 0H0Z" fill="white" />
  </svg>
);

export const RightArrow = () => (
  <svg
    width="41"
    height="12"
    viewBox="0 0 41 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 6.25C11.2466 6.25 20.5092 6.5 29.75 6.5"
      stroke="white"
      strokeOpacity="0.25"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M29.75 2C31.8742 3.06209 33.8872 4.32245 36 5.38889C36.6114 5.69748 38.8532 6.07137 38.75 7C38.6461 7.93504 35.6347 9.45511 34.75 9.75"
      stroke="white"
      strokeOpacity="0.25"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const Question = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="transition-all"
  >
    <rect width="15" height="15" rx="2" fill="#272626" />
    <path
      d="M6.67821 7.87806C6.67821 8.23497 6.80799 8.54861 7.06756 8.79736L8.0193 8.48372C7.8787 8.36475 7.78137 8.17008 7.78137 7.99703C7.78137 7.56442 8.1599 7.30485 8.57088 7.00202C9.11165 6.62349 9.71731 6.19088 9.71731 5.29321C9.71731 4.31983 8.88453 3.5952 7.5218 3.5952C6.54842 3.5952 5.71564 3.99537 5.16406 4.66592L5.88869 5.47707C6.25641 5.02282 6.73228 4.71999 7.39202 4.71999C8.09501 4.71999 8.41947 5.0769 8.41947 5.4987C8.41947 5.92049 8.06256 6.16924 7.6624 6.45044C7.19734 6.78572 6.67821 7.15344 6.67821 7.87806ZM6.69984 10.2791C6.69984 10.69 7.04593 11.0361 7.45691 11.0361C7.86789 11.0361 8.21398 10.69 8.21398 10.2791C8.21398 9.86808 7.86789 9.52199 7.45691 9.52199C7.04593 9.52199 6.69984 9.86808 6.69984 10.2791Z"
      fill="#999999"
      className="group-hover:fillWhite transition-colors"
    />
  </svg>
);

export const PathIcon = ({ fill }: { fill: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.25C0 1.00736 1.00736 0 2.25 0H13.75C14.9926 0 16 1.00736 16 2.25V8H14.5V2.25C14.5 1.83579 14.1642 1.5 13.75 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V13.75C1.5 14.1642 1.83579 14.5 2.25 14.5H8V16H2.25C1.00736 16 0 14.9926 0 13.75V2.25ZM9.24618 5C8.41986 5 7.75 5.66986 7.75 6.49618V7H8.75H9.5V8.5H8.75H7.75V9.50439C7.75 11.1588 6.40882 12.5 4.75439 12.5H4.00439V11H4.75439C5.58039 11 6.25 10.3304 6.25 9.50439V8.5H5.25H4.5V7H5.25H6.25V6.49618C6.25 4.84144 7.59144 3.5 9.24618 3.5H9.99618V5H9.24618Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 11.875C11.5 11.6679 11.6679 11.5 11.875 11.5H15.25H16V10H15.25H11.875C10.8395 10 10 10.8395 10 11.875C10 12.2971 10.1395 12.6866 10.3749 13C10.1395 13.3134 10 13.7029 10 14.125C10 15.1605 10.8395 16 11.875 16H15.25H16V14.5H15.25H11.875C11.6679 14.5 11.5 14.3321 11.5 14.125C11.5 13.9179 11.6679 13.75 11.875 13.75H14.25H15V12.25H14.25H11.875C11.6679 12.25 11.5 12.0821 11.5 11.875Z"
      fill={fill}
    />
  </svg>
);

export const ChevronDown = () => (
  <svg
    width="41"
    height="30"
    viewBox="0 0 41 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.2508 12.5001L25.7204 13.0304L20.8972 17.8536C20.5066 18.2442 19.8735 18.2442 19.483 17.8536L14.6597 13.0304L14.1294 12.5001L15.1901 11.4395L15.7204 11.9698L20.1901 16.4395L24.6598 11.9698L25.1901 11.4395L26.2508 12.5001Z"
      fill="#8F8F8F"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.125 4.875C1.125 2.80393 2.80393 1.125 4.875 1.125C6.94607 1.125 8.625 2.80393 8.625 4.875C8.625 6.94607 6.94607 8.625 4.875 8.625C2.80393 8.625 1.125 6.94607 1.125 4.875ZM4.875 0C2.18261 0 0 2.18261 0 4.875C0 7.56743 2.18261 9.75 4.875 9.75C6.01852 9.75 7.07008 9.35625 7.90148 8.697L10.4773 11.2727L10.875 11.6705L11.6705 10.875L11.2727 10.4773L8.697 7.90148C9.35625 7.07008 9.75 6.01852 9.75 4.875C9.75 2.18261 7.56743 0 4.875 0Z"
      fill="#8F8F8F"
    />
  </svg>
);

export const NetworkIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 0.625V1.09375V8.90625V9.375H7.8125V8.90625V1.09375V0.625H8.75ZM5.46875 3.75V4.21875V8.90625V9.375H4.53125V8.90625V4.21875V3.75H5.46875ZM2.1875 6.71875V6.25H1.25V6.71875V8.90625V9.375H2.1875V8.90625V6.71875Z"
      fill="black"
    />
  </svg>
);

export const QuestionIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="15" height="15" rx="2" fill="#272626" />
    <path
      d="M6.67821 7.87806C6.67821 8.23497 6.80799 8.54861 7.06756 8.79736L8.0193 8.48372C7.8787 8.36475 7.78137 8.17008 7.78137 7.99703C7.78137 7.56442 8.1599 7.30485 8.57088 7.00202C9.11165 6.62349 9.71731 6.19088 9.71731 5.29321C9.71731 4.31983 8.88453 3.5952 7.5218 3.5952C6.54842 3.5952 5.71564 3.99537 5.16406 4.66592L5.88869 5.47707C6.25641 5.02282 6.73228 4.71999 7.39202 4.71999C8.09501 4.71999 8.41947 5.0769 8.41947 5.4987C8.41947 5.92049 8.06256 6.16924 7.6624 6.45044C7.19734 6.78572 6.67821 7.15344 6.67821 7.87806ZM6.69984 10.2791C6.69984 10.69 7.04593 11.0361 7.45691 11.0361C7.86789 11.0361 8.21398 10.69 8.21398 10.2791C8.21398 9.86808 7.86789 9.52199 7.45691 9.52199C7.04593 9.52199 6.69984 9.86808 6.69984 10.2791Z"
      fill="#999999"
    />
  </svg>
);

export const WarningIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="mt-1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.40216 3.5C10.5568 1.5 13.4436 1.5 14.5983 3.5L20.6605 14C21.8152 16 20.3718 18.5 18.0624 18.5H5.93806C3.62866 18.5 2.18529 16 3.33999 14L9.40216 3.5Z"
      fill="#FFB800"
    />
    <path
      d="M12 16C12.6904 16 13.25 15.4404 13.25 14.75C13.25 14.0596 12.6904 13.5 12 13.5C11.3096 13.5 10.75 14.0596 10.75 14.75C10.75 15.4404 11.3096 16 12 16Z"
      fill="white"
    />
    <path
      d="M12 6.5V10.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
